import { render, staticRenderFns } from "./my-modal.vue?vue&type=template&id=4168a11c&scoped=true&"
import script from "./my-modal.vue?vue&type=script&lang=js&"
export * from "./my-modal.vue?vue&type=script&lang=js&"
import style0 from "./my-modal.vue?vue&type=style&index=0&id=4168a11c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4168a11c",
  null
  
)

export default component.exports